/* eslint-disable import/no-unresolved */
import {
  Addon,
  Footer as BaseFooter,
  Bottom,
  Column,
  Copyright,
  Finansportalen,
  Top,
} from 'footer/components';
import React from 'react';

import { FooterCooperation } from 'App/themes/FooterCooperation';
import { storebrandFooterAddon } from 'App/themes/PartnerTheme/partnerTheme.constants';
import { externalLink } from 'App/themes/PartnerTheme/partnerTheme.helpers';
import { FooterFlexContainer, FooterLink } from 'App/themes/themes.styles';
import { getAppText } from 'Utils/text';

interface FooterProps {
  brand: string;
}

export const Footer = ({ brand }: FooterProps): React.ReactElement => {
  return (
    <BaseFooter>
      <Top />
      <Bottom>
        <FooterFlexContainer>
          <Column>
            <FooterLink
              href="https://storebrand.no/om-storebrand/sikkerhet-og-personvern"
              target="_blank"
            >
              {getAppText('partnerFooter.personalDataLink.text')}
            </FooterLink>
            <FooterLink href={externalLink('kundeprofil')}>
              {getAppText('partnerFooter.profileLink.text')}
            </FooterLink>
            <Finansportalen />
            <Copyright />
          </Column>
          <Column>
            <Addon logo={{ ...storebrandFooterAddon }} />
            <FooterCooperation brand={brand} />
          </Column>
        </FooterFlexContainer>
      </Bottom>
    </BaseFooter>
  );
};
